var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"Default"}},[_c('layout',{attrs:{"content":_vm.stringtojson(_vm.kirby.page.strings.layout),"page":_vm.kirby.page}}),_c('mainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }